import { FormControlLabel } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { parseLabel } from '../../parseLabel'
import Checkbox from 'app/views/common-components/CustomCheckbox'

const useStyles = makeStyles(theme => ({
  root: {
    '& a': {
      color: theme.palette.secondaryDark.main,
      textDecoration: 'underline'
    }
  }
}))

export const FormBooleanPrintEditor = ({
  id,
  value,
  disabled,
  typeProps,
  langFR,
  titleFR,
  titleEN,
  title,
  ...props
}) => {
  title = title || (langFR ? titleFR : titleEN)
  const classes = useStyles()

  title = <div className={classes.root}>{parseLabel(title)}</div>

  return (
    <FormControlLabel
      control={<Checkbox disabled checked={Boolean(value)} />}
      label={title}
    />
  )
}
